import React, { useState } from 'react';
import './carousel.css';
import bio from '../../assets/biology.avif';
import geo from '../../assets/geography.jpeg';
import math from '../../assets/math.webp';

const SubjectCarousel = () => {
  const [selectedItem, setSelectedItem] = useState(1);

  const handleChangeItem = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className="body-test">
      <div className="container">
        <input 
          className="input-radio" 
          type="radio" 
          name="slider" 
          id="item-1" 
          checked={selectedItem === 1} 
          onChange={() => {}}
        />
        <input 
          className="input-radio" 
          type="radio" 
          name="slider" 
          id="item-2" 
          checked={selectedItem === 2} 
          onChange={() => {}}
        />
        <input 
          className="input-radio" 
          type="radio" 
          name="slider" 
          id="item-3" 
          checked={selectedItem === 3} 
          onChange={() => {}}
        />

        <div className="cards">
          <label 
            className="card" 
            htmlFor="item-1" 
            id="song-1" 
            onClick={() => handleChangeItem(1)}
          >
            <img className="img-test" src={geo} alt="Geography" />                      
            <p className="card-title">Geography</p>
          </label>

          <label 
            className="card" 
            htmlFor="item-2" 
            id="song-2" 
            onClick={() => handleChangeItem(2)}
          >
            <img className="img-test" src={bio} alt="Biology" />
            <p className="card-title">Biology</p>
          </label>

          <label 
            className="card" 
            htmlFor="item-3" 
            id="song-3" 
            onClick={() => handleChangeItem(3)}
          >
            <img className="img-test" src={math} alt="Mathematics" />
            <p className="card-title">Mathematics</p>
          </label>
        </div>
      </div>
    </div>
  );
};

export default SubjectCarousel;